import { TLD } from '@packages/common';

export const formatNumberWithLocale = (value: number, locale: TLD): string => {
  return value.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};
